import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Banner } from 'foundations-components/transitional/components/Banner';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import TableExample from './TableExample';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Header } from '../components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function KitchenSink() {
  const [toggleState, setToggleState] = useState({
    enabled: true,
    disabled: false,
    readOnly: true
  });
  const [progressValue, setProgressValue] = useState(45);
  const [activeComponent, setActiveComponent] = useState('table');
  const scrollToSection = sectionId => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setActiveComponent(sectionId);
    }
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INDEX_LOAD",
    children: /*#__PURE__*/_jsx(ListingPage, {
      headerComponent: Header,
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: "row",
        children: [/*#__PURE__*/_jsx(View, {
          minInlineSize: "250px",
          maxInlineSize: "250px",
          paddingBlock: "600",
          paddingInline: "400",
          position: "sticky",
          insetBlockStart: "0",
          alignSelf: "start",
          children: /*#__PURE__*/_jsxs(SideNav, {
            "aria-label": "Component Examples",
            value: activeComponent,
            children: [/*#__PURE__*/_jsx(SideNavItem, {
              value: "table",
              title: "Table",
              onClick: () => scrollToSection('table')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "buttons",
              title: "Buttons",
              onClick: () => scrollToSection('buttons')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "alerts",
              title: "Alerts",
              onClick: () => scrollToSection('alerts')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "banner",
              title: "Banner",
              onClick: () => scrollToSection('banner')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "badge",
              title: "Badge",
              onClick: () => scrollToSection('badge')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "toggle",
              title: "Toggle",
              onClick: () => scrollToSection('toggle')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "tag",
              title: "Tag",
              onClick: () => scrollToSection('tag')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "tabs",
              title: "Tabs",
              onClick: () => scrollToSection('tabs')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "status-tag",
              title: "StatusTag",
              onClick: () => scrollToSection('status-tag')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "progress",
              title: "Progress",
              onClick: () => scrollToSection('progress')
            }), /*#__PURE__*/_jsx(SideNavItem, {
              value: "link",
              title: "Link",
              onClick: () => scrollToSection('link')
            })]
          })
        }), /*#__PURE__*/_jsx(View, {
          flex: "1",
          paddingInlineStart: "600",
          children: /*#__PURE__*/_jsxs(TFlex, {
            direction: "column",
            gap: 50,
            children: [/*#__PURE__*/_jsx(View, {
              id: "table",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(TableExample, {})
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "buttons",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Buttons"
              }), /*#__PURE__*/_jsxs(TFlex, {
                gap: 20,
                wrap: "wrap",
                children: [/*#__PURE__*/_jsx(Button, {
                  use: "primary",
                  children: "Primary"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "secondary",
                  children: "Secondary"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "tertiary",
                  children: "Tertiary"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "tertiary-light",
                  children: "Tertiary Light"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "danger",
                  children: "Danger"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "primary",
                  size: "small",
                  children: "Small"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "primary",
                  size: "extra-small",
                  children: "Extra Small"
                }), /*#__PURE__*/_jsx(Button, {
                  use: "primary",
                  disabled: true,
                  children: "Disabled"
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "alerts",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Alerts"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsx(Alert
                // @ts-expect-error type not-permitted but required to apply theming for portals
                , {
                  color: "text-alert-default",
                  type: "info",
                  titleText: /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    children: "Information Alert"
                  }),
                  children: /*#__PURE__*/_jsx(Text, {
                    typography: "body-100",
                    children: "This is an informational alert message."
                  })
                }), /*#__PURE__*/_jsx(Alert
                // @ts-expect-error type not-permitted but required to apply theming for portals
                , {
                  color: "text-alert-default",
                  type: "warning",
                  titleText: /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    children: "Warning Alert"
                  }),
                  children: "This is a warning alert message."
                }), /*#__PURE__*/_jsx(Alert
                // @ts-expect-error type not-permitted but required to apply theming for portals
                , {
                  color: "text-alert-default",
                  titleText: /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    children: "Success Alert"
                  }),
                  type: "success",
                  children: "This is a success alert message."
                }), /*#__PURE__*/_jsx(Alert
                // @ts-expect-error type not-permitted but required to apply theming for portals
                , {
                  color: "text-alert-default",
                  type: "danger",
                  titleText: /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    children: "Danger Alert"
                  }),
                  children: "This is a danger alert message."
                }), /*#__PURE__*/_jsx(Alert
                // @ts-expect-error type not-permitted but required to apply theming for portals
                , {
                  color: "text-core-default",
                  type: "tip",
                  titleText: /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    children: "Tip Alert"
                  }),
                  children: "This is a tip alert message."
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "banner",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Banner Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsx(Banner, {
                  titleText: "You've used 4 out of 5 templates.",
                  closeable: true,
                  onClose: () => console.log('Banner closed'),
                  children: "Unlock unlimited templates with HubSpot Sales Pro."
                }), /*#__PURE__*/_jsx(Banner, {
                  titleText: "New feature available!",
                  closeable: false,
                  children: "Check out our latest updates and improvements."
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "badge",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Badge Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                gap: 20,
                wrap: "wrap",
                children: [/*#__PURE__*/_jsx(Badge, {
                  use: "free",
                  children: "Free"
                }), /*#__PURE__*/_jsx(Badge, {
                  use: "beta",
                  children: "Beta"
                }), /*#__PURE__*/_jsx(Badge, {
                  use: "new",
                  children: "New"
                }), /*#__PURE__*/_jsx(Badge, {
                  use: "dot",
                  children: "Dot"
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "toggle",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Toggle Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsx(FormControl, {
                  label: "Enabled Toggle",
                  children: /*#__PURE__*/_jsx(Toggle, {
                    id: "toggle-enabled",
                    checked: toggleState.enabled,
                    onChange: ({
                      target: {
                        checked
                      }
                    }) => setToggleState(prev => Object.assign({}, prev, {
                      enabled: checked
                    }))
                  })
                }), /*#__PURE__*/_jsx(FormControl, {
                  label: "Disabled Toggle",
                  children: /*#__PURE__*/_jsx(Toggle, {
                    id: "toggle-disabled",
                    checked: toggleState.disabled,
                    disabled: true
                  })
                }), /*#__PURE__*/_jsx(FormControl, {
                  label: "Read Only Toggle",
                  children: /*#__PURE__*/_jsx(Toggle, {
                    id: "toggle-readonly",
                    checked: toggleState.readOnly,
                    readOnly: true
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "tag",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Tag Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsxs(TFlex, {
                  gap: 10,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(Tag, {
                    use: "default",
                    children: "Default"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "paused",
                    children: "Paused"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "draft",
                    children: "Draft"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "disabled",
                    children: "Disabled"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "primary",
                    children: "Primary"
                  })]
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(Tag, {
                    use: "success",
                    children: "Success"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "active",
                    children: "Active"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "sent",
                    children: "Sent"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "published",
                    children: "Published"
                  })]
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(Tag, {
                    use: "warning",
                    children: "Warning"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "inReview",
                    children: "In Review"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "scheduled",
                    children: "Scheduled"
                  })]
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(Tag, {
                    use: "error",
                    children: "Error"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "cancelled",
                    children: "Cancelled"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "removed",
                    children: "Removed"
                  }), /*#__PURE__*/_jsx(Tag, {
                    use: "danger",
                    children: "Danger"
                  })]
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "tabs",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Tabs Component"
              }), /*#__PURE__*/_jsxs(Tabs, {
                defaultSelected: "tab1",
                children: [/*#__PURE__*/_jsx(Tab, {
                  id: "tab1",
                  title: "First Tab",
                  children: /*#__PURE__*/_jsx(View, {
                    padding: "400",
                    children: /*#__PURE__*/_jsx(Paragraph, {
                      children: "This is the content of the first tab."
                    })
                  })
                }), /*#__PURE__*/_jsx(Tab, {
                  id: "tab2",
                  title: "Second Tab",
                  children: /*#__PURE__*/_jsx(View, {
                    padding: "400",
                    children: /*#__PURE__*/_jsx(Paragraph, {
                      children: "This is the content of the second tab."
                    })
                  })
                }), /*#__PURE__*/_jsx(Tab, {
                  id: "tab3",
                  title: "Third Tab",
                  children: /*#__PURE__*/_jsx(View, {
                    padding: "400",
                    children: /*#__PURE__*/_jsx(Paragraph, {
                      children: "This is the content of the third tab."
                    })
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "status-tag",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "StatusTag Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(StatusTag, {
                    use: "default",
                    children: "Default"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "paused",
                    children: "Paused"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "draft",
                    children: "Draft"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "disabled",
                    children: "Disabled"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "primary",
                    children: "Primary"
                  })]
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(StatusTag, {
                    use: "success",
                    children: "Success"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "active",
                    children: "Active"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "sent",
                    children: "Sent"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "published",
                    children: "Published"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "warning",
                    children: "Warning"
                  })]
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(StatusTag, {
                    use: "inReview",
                    children: "In Review"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "scheduled",
                    children: "Scheduled"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "removed",
                    children: "Removed"
                  }), /*#__PURE__*/_jsx(StatusTag, {
                    use: "error",
                    children: "Error"
                  })]
                }), /*#__PURE__*/_jsx(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: /*#__PURE__*/_jsx(StatusTag, {
                    use: "info",
                    children: "Info"
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(View, {
              as: "div",
              id: "progress",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Progress Component"
              }), /*#__PURE__*/_jsx(TFlex, {
                direction: "column",
                gap: 20,
                children: /*#__PURE__*/_jsxs(View, {
                  children: [/*#__PURE__*/_jsx(FormLabel, {
                    htmlFor: "progress-control",
                    children: "Progress Control"
                  }), /*#__PURE__*/_jsxs(TFlex, {
                    gap: 20,
                    alignItems: "center",
                    marginBlockStart: "200",
                    children: [/*#__PURE__*/_jsx(Button, {
                      size: "small",
                      onClick: () => setProgressValue(Math.max(0, progressValue - 10)),
                      children: "Decrease"
                    }), /*#__PURE__*/_jsx(Button, {
                      size: "small",
                      onClick: () => setProgressValue(Math.min(100, progressValue + 10)),
                      children: "Increase"
                    })]
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs(View, {
              id: "link",
              marginBlockEnd: "400",
              children: [/*#__PURE__*/_jsx(H4, {
                marginBlockEnd: "400",
                children: "Link Component"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                gap: 20,
                children: [/*#__PURE__*/_jsx(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: "https://www.hubspot.com",
                    children: "Standard Link"
                  })
                }), /*#__PURE__*/_jsxs(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: [/*#__PURE__*/_jsx(Link, {
                    disabled: true,
                    children: "Disabled Link"
                  }), /*#__PURE__*/_jsx(Link, {
                    external: true,
                    children: "External Link"
                  }), /*#__PURE__*/_jsx(Link, {
                    use: "unstyled",
                    children: "Unstyled link"
                  }), /*#__PURE__*/_jsx(Link, {
                    underline: true,
                    children: "Underlined Link"
                  })]
                }), /*#__PURE__*/_jsx(TFlex, {
                  gap: 20,
                  wrap: "wrap",
                  children: /*#__PURE__*/_jsx(Link, {
                    use: "mention",
                    children: "@Mention Link"
                  })
                })]
              })]
            })]
          })
        })]
      })
    })
  });
}